import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Card, Type, Anchor } from "discover.medical.react-component-library";
import { StyledDivider } from "./_styled";
import { getSeamlessLink } from "../../util/seamlessAuth";
import { logDecisionsPlacardClicked } from "../../util/analytics";

const ContentRightRailDDTools = ({ tools, pathToAllTools, telemetryData }) => {
  if (!tools?.length) {
    return null;
  }

  return (
    <Card borderWidth="1px" borderStyle="solid" borderColor="gray400">
      <Card
        padding="sm"
        backgroundColor="quinary"
        borderBottomWidth="1px"
        borderStyle="solid"
        borderColor="gray400"
      >
        <Type element="h2" styledAs="i" fontSize="sm" fontFamily="secondary">
          See also on DynaMed Decisions
        </Type>
      </Card>
      <Card padding="sm">
        {tools.map(({ an, title, slug, description }) => (
          <Fragment key={an}>
            <Anchor
              fontWeight="semibold"
              linkComponent="a"
              fontSize="sm"
              href={getSeamlessLink(slug)}
              onClick={() => {
                logDecisionsPlacardClicked({
                  ...telemetryData,
                  an,
                  title,
                });
              }}
            >
              {title}
            </Anchor>
            <Type fontSize="xs">{description}</Type>
            <StyledDivider />
          </Fragment>
        ))}
        <Type element="i" fontSize="sm">
          Did you know your subscription includes access to{" "}
          <Anchor
            fontWeight="semibold"
            fontSize="sm"
            linkComponent="a"
            href={getSeamlessLink(pathToAllTools)}
          >
            all DynaMed Decisions tools
          </Anchor>
          ?
        </Type>
      </Card>
    </Card>
  );
};

ContentRightRailDDTools.propTypes = {
  pathToAllTools: PropTypes.string,
  tools: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};
export default ContentRightRailDDTools;
